import { ADD_SUBJECT } from '../actionTypes';
import { Product } from '../../services/models/product';

interface Action {
  type: string;
  payload: Product;
}

const subjects = (subjects = [], action: Action): Product[] => {
  switch (action.type) {
    case ADD_SUBJECT:
      return subjects.find(s => s.id === action.payload?.id)
        ? subjects.filter(subject => subject.id !== action.payload?.id)
        : [...subjects, action.payload];

    default:
      return subjects;
  }
};

export default subjects;
